class TwoFactorService {
  constructor() {
    this.pendingRequest = null;
    this.twoFactorComponent = null;
  }
  
  // Register the 2FA component instance
  registerComponent(component) {
    this.twoFactorComponent = component;
  }
  
  // Show the 2FA modal
  show2FAModal(context) {
    return new Promise((resolve, reject) => {

      
      if (!this.twoFactorComponent) {
        reject(new Error('2FA component not registered'));
        return;
      }
      
      // Store the context for retry
      this.pendingRequest = context.originalRequest;
      
      // Create event handlers
      const handleVerified = async (result) => {
        cleanup();
        
        // Retry the original request if available
        if (this.pendingRequest && window.vcCommunicator) {
          try {
            const retryResponse = await window.vcCommunicator.retryRequestAfter2FA(this.pendingRequest);
            resolve(retryResponse);
          } catch (error) {
            reject(error);
          } finally {
            this.pendingRequest = null;
          }
        } else {
          resolve(result);
        }
      };
      
      const handleCancelled = () => {
        cleanup();
        this.pendingRequest = null;
        reject(new Error('2FA verification cancelled'));
      };
      
      const handleError = (error) => {
        cleanup();
        this.pendingRequest = null;
        reject(error);
      };
      
      const cleanup = () => {
        // Remove stored handlers
        delete this.twoFactorComponent._twoFactorHandlers;
      };
      
      // Store handlers for the component to call
      this.twoFactorComponent._twoFactorHandlers = {
        verified: handleVerified,
        cancelled: handleCancelled,
        error: handleError
      };
      
      // Use a method to show the modal instead of direct property mutation
      this.twoFactorComponent.showWithContext(context);
    });
  }
}

export default new TwoFactorService();